import React from 'react';
import whatsappIcon from './assets/whatsapp-white.png';
import instagramIcon from './assets/instagram-white.png';
import gmailIcon from './assets/gmail-white.png';

const Footer = () => {
  return (
    <footer
      className="text-white py-20 mt-20 text-center relative"
      style={{
        background: 'linear-gradient(180deg, var(--color-dark) 0%, #0d2b48 60%, #15385e 100%)',
      }}
    >
      {/* BLOQUE CTA */}
      <div className="max-w-4xl mx-auto px-6 mb-12">
        <h3 className="text-3xl font-bold mb-4 text-white">¿Hablamos?</h3>
        <p className="text-lg mb-8 leading-relaxed text-white/90">
          Si querés llevar tu emprendimiento al siguiente nivel, estoy para ayudarte.  
          Conversemos y encontremos la mejor solución para vos.
        </p>

        <a
          href="https://wa.me/5493585727260"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-[var(--color-dark)] px-8 py-3 rounded-full font-semibold hover:scale-105 transition-transform shadow-md"
        >
          Escribime por WhatsApp
        </a>
      </div>

      {/* SEPARADOR */}
      <div className="w-24 h-[2px] bg-[var(--color-accent)] mx-auto mb-10 opacity-80"></div>

      {/* BLOQUE REDES Y COPYRIGHT */}
      <h3 className="text-3xl font-bold mb-4 text-white">Nuestras redes</h3>
      <div className="flex flex-col items-center space-y-4">
        <div className="flex space-x-6">
          <a
            href="https://wa.me/5493585727260"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition"
          >
            <img src={whatsappIcon} alt="WhatsApp" className="w-6 h-6" />
          </a>

          <a
            href="https://www.instagram.com/admify_solucionesintegrales/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition"
          >
            <img src={instagramIcon} alt="Instagram" className="w-6 h-6" />
          </a>

          <a
            href="mailto:admifysolucionesintegrales@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition"
          >
            <img src={gmailIcon} alt="Gmail" className="w-6 h-6" />
          </a>
        </div>

        <p className="text-sm text-white/80">
          © 2025 Admify - Todos los derechos reservados
        </p>
        <p className="text-xs text-white/60">
          Realizado por Admify - Soluciones Integrales
        </p>
      </div>
    </footer>
  );
};

export default Footer;


